import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';

/**
 * size is optional helps to adjust the size of the icon
 * @param {string} name - the name of the icon
 * @param {string} label - the label of the page
 * @param {string} size - the size of the icon
 * @param {string} wrapDivClass - the className for the wrapper div
 * @param {string} dataTestId - the test id for the icon returned by the header
 * @param {string} headingTestId - the test id for the h1 returned by the header
 */

const PagesHeader = ({
  name, label, size = undefined, wrapDivClass = 'py-2.5', dataTestId = undefined, headingTestId = undefined,
}) => {
  return (
    <div className={wrapDivClass}>
      <div className="flex items-center gap-2.5 mr-10">
        {name && (
          <Icon
            name={name}
            className={size}
            dataTestId={dataTestId}
          />
        )}
        <h1 className="text-32 font-sans font-bold" data-testid={headingTestId}>{label}</h1>
      </div>
    </div>
  );
};

PagesHeader.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.string,
  wrapDivClass: PropTypes.string,
  dataTestId: PropTypes.string,
  headingTestId: PropTypes.string,
};
export default PagesHeader;
